import {
  Array,
  Boolean,
  Number,
  Partial,
  Record,
  Static,
  String,
  Undefined,
  Union,
} from "runtypes";
import { ResponseSummaryResponseRuntype } from "./IResponseSummaryResponse";

const ResponseScalarSummaryListRuntype = Record({
  averages: Array(
    Record({
      category: Number,
      coachScore: Number,
      order: Number,
      parentScore: Number,
      studentScore: Number,
      text: String,
    })
  ),
  coachTotalAverage: Number,
  parentTotalAverage: Number,
  studentTotalAverage: Number,
});

const ResponseWrittenRuntype = Record({
  response: String,
  surveyQuestionId: Number,
});

const SurveyScalarResponseSummariesRuntype = Record({
  expectations: ResponseScalarSummaryListRuntype,
  other: ResponseScalarSummaryListRuntype,
  parent: ResponseScalarSummaryListRuntype,
  warmth: ResponseScalarSummaryListRuntype,
});

const ChampionsComparisonRuntype = Record({
  coachScores: Array(
    Record({
      category: Number,
      order: Number,
      coachScore: Number,
    })
  ),
});

const Question = Record({
  category: Number,
  coachText: String,
  id: Number,
  parentText: String,
  studentText: String,
});

export interface ISurveyScalarResponseSummaries
  extends Static<typeof SurveyScalarResponseSummariesRuntype> {}

export const SurveyEvaluationResponseRuntype = Record({
  coachCommitments: String,
  coachResponses: Array(ResponseWrittenRuntype),
  count: Record({
    coachCount: Number,
    parentCount: Number,
    studentCount: Number,
  }),
  directorComments: String,
  enableParentQuestions: Boolean,
  hasWrittenQuestions: Boolean,
  parentComments: String,
  parentResponses: Array(Union(String, Undefined)),
  questions: Array(Question),
  responseCollectionEndDate: Number,
  scaleResponseSummaries: SurveyScalarResponseSummariesRuntype,
  sportId: Number,
  startDate: Number,
  submitted: Boolean,
  type: Number,
  entryLevel: Number,
  isCoachSelfAssessmentOnly: Boolean,
  writtenResponseSummaries: Array(ResponseSummaryResponseRuntype),
}).And(
  Partial({
    championsComparison: ChampionsComparisonRuntype,
  })
);

export interface ISurveyEvalResponse
  extends Static<typeof SurveyEvaluationResponseRuntype> {}



// WEBPACK FOOTER //
// ./src/services/ISurveyEvaluationResponse.ts